import * as Source from 'shared/models/sources';
import yup, { ErrorLengthMax, ErrorLengthMin } from 'utils/yup-form-validator';

export type FormValuesT = {
  name: string;
  comment: string;
  deviceId: string;
  sourceTechnology: string;
  addressIPv6: string;
  addressIPv4: string;
}

export type APIFormBody = {
  name: string;
  comment: string;
  deviceId: string;
  addressIPv6: string;
  addressIPv4: string;
  isIPv4: boolean;
  deviceProfileId: string;
  poolId: string; // IP Network ID
}

export const formOneValidator = yup.object({
  name: yup.string().min(3, ErrorLengthMin(3)).max(48, ErrorLengthMax(48))
    .isAlphanumericHypenBracketSpace()
    .required(),
  comment: yup.string().max(128, ErrorLengthMax(128)),
  deviceId: yup.string()
    .when('sourceTechnology', {
      is: Source.SOURCE_TECHNOLOGY_LORAWAN,
      then: yup.string().matches(
        Source.DeviceIDRequirement.LORAWAN.regex as RegExp,
        Source.DeviceIDRequirement.LORAWAN.regexHelper,
      ).required(),
    })
    .when('sourceTechnology', {
      is: Source.SOURCE_TECHNOLOGY_SIGFOX,
      then: yup.string().matches(
        Source.DeviceIDRequirement.SIGFOX.regex as RegExp,
        Source.DeviceIDRequirement.SIGFOX.regexHelper,
      ).required(),
    }),
  addressIPv6: yup.string().ipv6('Invalid IPv6 address'),
  addressIPv4: yup.string().ipv4('Invalid IPv4 address'),
});

export const formEmptyValidator = yup.object();
